@if (item && item.items) {
  <div class="pane-wrapper">
    <div
      class="pane bg-white border-r border-gray-300 scrollable-y scrollbar-thin scrollbar-thumb-blue-200 scrollbar-thumb-rounded-md scrollbar-track-blue-50 hover:scrollbar-thumb-blue-200"
    >
      @if (canSelectAll) {
        <div
          class="w-full h-10 flex items-center pxl-075 text-gray-900 bg-white hover:bg-gray-50 active:bg-gray-200 cursor-pointer border-b border-gray-300"
        >
          <mat-checkbox
            [indeterminate]="isIndeterminate"
            [checked]="isSelectAllChecked"
            (change)="selectAllCheckboxChanged($event)"
            labelPosition="after"
            ><span class="text-base md:text-sm text-gray-900 font-medium ml-2">Select all</span>
          </mat-checkbox>
        </div>
      }
      <!-- <ng-container *ngIf="itemsList && itemsList.length">
      <div *ngFor="let item of itemsList"
        class="panel-option w-full h-10 flex items-center px-3 py-3 text-gray-900 font-medium cursor-pointer border-b border-gray-300"
        [ngClass]="{'active': selectedItem?.label === item.label}"
        (click)="containerItemSelected(item);">
        <div class="flex-1">{{item.label}}</div>
        <app-continuation-indicator [isActive]="selectedItem?.label === item.label"></app-continuation-indicator>
      </div>
    </ng-container> -->
      @if (hierarchyContainerItemsList && hierarchyContainerItemsList.length) {
        <mat-selection-list
          class="filter-item-select-list"
          #selectList
          [(ngModel)]="selectedHierarchyContainerItems"
          (selectionChange)="hierarchyContainerItemsChanged($event)"
        >
          @for (
            item of hierarchyContainerItemsList;
            track item;
            let idx = $index;
            let first = $first;
            let last = $last
          ) {
            <mat-list-option checkboxPosition="before" [value]="item" class="select-list-item">
              <div
                [id]="'c_' + idx"
                class="w-full h-10 flex items-center pr-3 text-gray-900 font-medium cursor-pointer"
              >
                <div class="flex-1 truncate" [title]="item.label">{{ item.label }}</div>
                @if (item.items?.length && canSelectChildren) {
                  <app-continuation-indicator
                    [isActive]="selectedContainerMap[idx] ?? false"
                  ></app-continuation-indicator>
                }
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
      }
      @if (hierarchyFacetItemsList && hierarchyFacetItemsList.length) {
        <mat-selection-list
          class="filter-item-select-list"
          #selectList
          [(ngModel)]="selectedHierarchyFacetItems"
          (selectionChange)="hierarchyFacetItemsChanged($event)"
        >
          @for (item of hierarchyFacetItemsList; track item; let idx = $index; let first = $first; let last = $last) {
            <mat-list-option checkboxPosition="before" [value]="item" class="select-list-item">
              <div
                [id]="'f_' + idx"
                class="flex-1 truncate text-base md:text-sm text-gray-900 font-medium"
                [title]="item.label"
              >
                {{ item.label }}
              </div>
              <!-- <app-continuation-indicator [isActive]="selectedFacetOption && selectedFacetOption.label === facet.label"
            [facet]="facet"
            [parentData]="facetData">
          </app-continuation-indicator> -->
            </mat-list-option>
          }
        </mat-selection-list>
      }
    </div>
  </div>
} @else {
  <div class="w-full h-full flex items-center justify-items-center">No Facet Data!!</div>
}
